import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <AboutSection />
        <ContactSection />
        <AppSection />
        <CarouselSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
        <UpdatesSection />
        <FaqSection />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}